import { t } from 'i18next';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'; // <-- 1. IMPORT useSelector

// Your existing subtexts for fallback
const subtexts = [
  "Analyzing your query",
  "Formulating a response",
  "Just a moment",
];

const ThinkingLoader = () => {
  // <-- 2. GET THE STATUS MESSAGE FROM REDUX
  const apiStatusMessage = useSelector(state => state.AIChat.streamingStatusMessage);

  const [currentSubtext, setCurrentSubtext] = useState('');
  const [elapsedTime, setElapsedTime] = useState(0);

  // This effect hook handles the timer and the cycling subtext
  useEffect(() => {
    // Pick an initial random subtext
    const randomIndex = Math.floor(Math.random() * subtexts.length);
    setCurrentSubtext(subtexts[randomIndex]);
    
    // Cycle the fallback subtext every 3 seconds
    const subtextInterval = setInterval(() => {
        const newIndex = Math.floor(Math.random() * subtexts.length);
        setCurrentSubtext(subtexts[newIndex]);
    }, 3000);

    // Start the timer
    const timerInterval = setInterval(() => {
      setElapsedTime(prevTime => prevTime + 10);
    }, 10);

    // Cleanup function to stop everything when the component is removed
    return () => {
      clearInterval(subtextInterval);
      clearInterval(timerInterval);
    };
  }, []); // Empty array ensures this runs only on mount and unmount

  // Format the time for display
  const seconds = Math.floor(elapsedTime / 1000);
  const milliseconds = String(Math.floor((elapsedTime % 1000) / 10)).padStart(2, '0');
  
  // <-- 3. DETERMINE WHICH MESSAGE TO DISPLAY
  // If the API provides a message, use it. Otherwise, use the cycling fallback text.
  const displayMessage = apiStatusMessage || currentSubtext;

  return (
    <li className="chat-list left">
      <div className="conversation-list">
        <div className="user-chat-content">
          <div className="thinking-loader-bubble">
            <div className="thinking-header">
              <i className="ri-robot-2-line"></i>
              <span className='me-3 mr-3'>{t("Thinking")}</span>
              <div className="dot-pulse">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </div>

            <p 
              className="thinking-footer mb-0" 
              style={{ 
                marginTop: '8px', 
                fontSize: '0.9em',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '1rem'
              }}
            >
              {/* Span for the status text */}
              <span style={{ 
                color: '#6c757d',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {t(displayMessage)}
              </span>

              <span style={{ fontFamily: 'monospace', color: '#212529', fontWeight: '500', flexShrink: 0 }}>
                {seconds}.{milliseconds}s
              </span>
            </p>
          </div>
        </div>
      </div>
    </li>
  );
};

export default ThinkingLoader;